import {createRouter, createWebHistory} from '@ionic/vue-router';
import {RouteRecordRaw} from 'vue-router';
import TabsPage from '../views/TabsPage.vue'
import {updateSeo} from '@/utils/seo';

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        component: TabsPage,
        redirect: '/home',
        children: [
            {
                path: 'home',
                name: 'HomePage',
                component: () => import('@/views/TabStore.vue'),
                meta: {
                    seo: {
                        title: 'ซื้อสลากดิจิทัล | ลอตเตอรี่สนามบินน้ำ',
                        description: 'ซื้อสลากดิจิทัลออนไลน์กับลอตเตอรี่สนามบินน้ำ ค้นหาเลขเด็ด เลือกเลขที่ต้องการ และจองสลากได้สะดวก',
                        path: '/home',
                    }
                }
            },
            {
                path: 'myLottery',
                name: 'MyLotteryPage',
                component: () => import('@/views/TabMyLottery.vue'),
                meta: {
                    seo: {
                        title: 'สลากของฉัน | ลอตเตอรี่สนามบินน้ำ',
                        description: 'ดูรายการสลากดิจิทัลของฉัน ตรวจสถานะ และติดตามสลากที่ซื้อไว้',
                        path: '/myLottery',
                        robots: 'noindex,nofollow',
                    }
                }
            },
            {
                path: 'profile',
                component: () => import('@/views/TabProfile.vue'),
                meta: {
                    seo: {
                        title: 'โปรไฟล์ | ลอตเตอรี่สนามบินน้ำ',
                        description: 'จัดการข้อมูลบัญชี ตั้งค่าภาษา และข้อมูลส่วนตัวในลอตเตอรี่สนามบินน้ำ',
                        path: '/profile',
                        robots: 'noindex,nofollow',
                    }
                }
            },
            {
                path: 'reward',
                component: () => import('@/views/reward/index.vue'),
                meta: {
                    seo: {
                        title: 'ตรวจผลรางวัล | ลอตเตอรี่สนามบินน้ำ',
                        description: 'ตรวจผลรางวัลสลาก ตรวจเลขรางวัล และดูข้อมูลการขึ้นเงินรางวัลกับลอตเตอรี่สนามบินน้ำ',
                        path: '/reward',
                    }
                }
            },
            {
                path: 'event',
                component: () => import('@/views/TabEvent.vue'),
                meta: {
                    seo: {
                        title: 'กิจกรรม | ลอตเตอรี่สนามบินน้ำ',
                        description: 'ติดตามกิจกรรม โปรโมชัน และสิทธิพิเศษจากลอตเตอรี่สนามบินน้ำ',
                        path: '/event',
                    }
                }
            },
        ]
    },
    {
        path: '/lottery/search',
        component: () => import('@/views/store/Search.vue'),
        meta: {
            seo: {
                title: 'ค้นหาสลาก | ลอตเตอรี่สนามบินน้ำ',
                description: 'ค้นหาเลขสลากดิจิทัลที่ต้องการจากลอตเตอรี่สนามบินน้ำ',
                path: '/lottery/search',
                robots: 'noindex,follow',
            }
        }
    },
    {
        path: '/payment',
        component: () => import('@/views/payment/Index.vue'),
        meta: {
            seo: {
                title: 'ชำระเงิน | ลอตเตอรี่สนามบินน้ำ',
                description: 'หน้าชำระเงินสำหรับคำสั่งซื้อสลากดิจิทัลในลอตเตอรี่สนามบินน้ำ',
                path: '/payment',
                robots: 'noindex,nofollow',
            }
        }
    },
    {
        path: '/auth/login',
        component: () => import('@/views/auth/Login.vue'),
        meta: {
            seo: {
                title: 'เข้าสู่ระบบ | ลอตเตอรี่สนามบินน้ำ',
                description: 'เข้าสู่ระบบลอตเตอรี่สนามบินน้ำเพื่อซื้อสลากดิจิทัลและจัดการบัญชีของคุณ',
                path: '/auth/login',
                robots: 'noindex,nofollow',
            }
        }
    },
    {
        path: '/auth/callback',
        component: () => import('@/views/auth/CallBack.vue'),
        meta: {
            seo: {
                title: 'กำลังเข้าสู่ระบบ | ลอตเตอรี่สนามบินน้ำ',
                description: 'หน้าดำเนินการเข้าสู่ระบบลอตเตอรี่สนามบินน้ำ',
                path: '/auth/callback',
                robots: 'noindex,nofollow',
            }
        }
    },
    {
        path: '/redirect/:af',
        component: () => import('@/views/redirect/af.vue'),
        meta: {
            seo: {
                title: 'เปลี่ยนเส้นทาง | ลอตเตอรี่สนามบินน้ำ',
                description: 'หน้าสำหรับเปลี่ยนเส้นทางไปยังลอตเตอรี่สนามบินน้ำ',
                robots: 'noindex,nofollow',
            }
        }
    },
]

const router = createRouter({
    history: createWebHistory('/'),
    routes
})

router.afterEach((to) => {
    updateSeo(to);
});

export default router
